import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { LogoSize } from './Logo';

interface StyledLogoProps {
  $size: LogoSize;
}

const sizeStyles = {
  sm: css`
    svg {
      width: 32px;
      height: 32px;
    }
  `,
  md: css`
    svg {
      width: 48px;
      height: 48px;
    }
  `,
  lg: css`
    svg {
      width: 64px;
      height: 64px;
    }
  `,
};

export const StyledLogo = styled.div<StyledLogoProps>`
  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme.space[3]};

  svg {
    flex-shrink: 0;
  }

  ${(props) => sizeStyles[props.$size]}
`;

export const StyledLogoText = styled.span`
  font-size: ${(props) => props.theme.font.size.h4};
  font-weight: ${(props) => props.theme.font.weight.bold};
  color: ${(props) => props.theme.colors.primary.navy};
  white-space: nowrap;
`;
